// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RVJTq","spinner":"styles_spinner__3lmvW","text":"styles_text__zPeh3"};